{
  "players": [
    {
      "name": "Mustafa Kemal",
      "type": "Human",
      "faction": "Turkey"
    },
    {
      "name": "Eleftherios Venizelos",
      "type": "AI",
      "faction": "Greece",
      "successions": [{ "variable": "venizelos.fell", "name": "Dimitrios Rallis" }]
    },
    {
      "name": "Aleksandar Stamboliyski",
      "type": "AI",
      "faction": "Bulgaria"
    },
    {
      "name": "Hovhannes Kajaznuni",
      "type": "AI",
      "faction": "Armenia"
    },
    {
      "name": "Vittorio Emanuele Orlando",
      "type": "AI",
      "faction": "Italy"
    },
    {
      "name": "David Lloyd George",
      "type": "AI",
      "faction": "Britain",
      "successions": [{ "variable": "britain.stoodDown", "name": "Andrew Bonar Law" }]
    },
    {
      "name": "Georges Clemenceau",
      "type": "AI",
      "faction": "France"
    }
  ]
}
